"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationNotificationEvent = void 0;
var ConversationNotificationEvent;
(function (ConversationNotificationEvent) {
    ConversationNotificationEvent["StatusChange"] = "StatusChange";
    ConversationNotificationEvent["Assigned"] = "Assigned";
})(ConversationNotificationEvent = exports.ConversationNotificationEvent || (exports.ConversationNotificationEvent = {}));
//# sourceMappingURL=SendConversationNotificationJobInput.js.map